import Splide from 'splide';
export const init = () =>{
	prdCarousel();
	reviewAcc();
	lineupAcc();
}


const prdCarousel = () =>{
	let spCar;
	const setSplide = (targ) =>{
		let reMount=false;
		let targObj=document.getElementById(targ);
		let sldCnt=targObj.querySelector("ul.splide__list").childElementCount;
		let target = "#"+targ+" .splide";
		
		let options = {
			type:'fade',
			mediaQuery: 'max',
			perPage: 1,
			perMove:1,
			arrows:false,
			pagination:false,
			focus:0,
			drag:false,
			//gap:"0px",
			autoplay: 'pause',
			interval: 5000,
			speed: 500,
			pauseOnFocus: false,
		}
		
		function setMountFunc( Splide, Components, options ) {
			const mount=()=> {
				Splide.on( 'mounted', function () {
					
				});
				Splide.on( 'move', function (e) {
					
				});
				
				Splide.on( 'moved', function (e) {
					
				});
			}

			return {
				mount,
			};
		}
		spCar=new Splide(target, options).mount({setMountFunc});
	}
	
	
	const setImgNav = () =>{
		const navUl=document.querySelector(".navImgs");
		const prdImgs=document.querySelectorAll(".splide__slide");
		if(prdImgs.length>1){
			let no=0;
			prdImgs.forEach((o) =>{
				const img=o.querySelector('img');
				const li=document.createElement('li');
				const atag=document.createElement('a');
				atag.setAttribute('href', "#");
				atag.appendChild(img.cloneNode(true));
				atag.classList.add("image");
				atag.dataset.no=no;
				atag.insertAdjacentHTML('afterbegin', '<div class="loaderWrap" ref="ldr"><div class="loader"></div></div>');
				li.appendChild(atag);
				navUl.appendChild(li);
				if(no==0){
					li.classList.add("active");
				}
				atag.addEventListener("click",(e) =>{
					e.preventDefault();
					let trg=e.currentTarget;
					if(!trg.classList.contains("active")){
						const actNav=navUl.querySelectorAll(".active");
						actNav.forEach((n) =>{
							n.classList.remove("active");
						});
						trg.closest("li").classList.add("active");
						spCar.go(Number(trg.dataset.no));
					}
				});
				no++;
			});
		}
		
	}
	
	const rmvLoader = () =>{
		const allImg=document.querySelectorAll(".lazyload");
		allImg.forEach((o)=>{
			o.onload=function(e){
				e.target.closest(".image").querySelector(".loaderWrap").remove();
			}
		});
	}
	
	
	setImgNav();
	setSplide("prdSplide");
	rmvLoader();
	lazyload();
}


const reviewAcc = () =>{
	const rvSect=document.querySelector(".dtlReview");
	if(rvSect==null){
		return false;
	}
	
	const rvBt=rvSect.querySelector(".opBt");
	const rvWrap=document.getElementById("revList");
	const popList=rvWrap.querySelectorAll("li");
	let accFlg=true;
	let ocH;
	
	const rvInit = () =>{
		if(popList.length<=2){
			accFlg=false;
		}
		
		popList.forEach((rv) =>{
			const hartsWrap=rv.querySelector(".harts");
			const harts=Number(hartsWrap.textContent);
			hartsWrap.textContent="";
			for(let i=0;i<harts;i++){
				hartsWrap.insertAdjacentHTML('beforeend','<img src="/products/img/ic-heart.png" alt="">');
			}
		});
		
		ocH=mathHeght();
		
		const term = 300;// タイマーの受取変数
		let timer = 0; 
		window.addEventListener('resize', ()=>{
			rvClose()
			clearTimeout(timer);
			timer = setTimeout(function(){
				ocH=mathHeght();
				/*
				if(rvWrap.ariaHidden=="true"){
					rvClose();
				}else{
					rvOpen();
				}
				*/
			}, term);
		});
	}
	
	
	const mathHeght = () =>{
		let cnt=0;
		let ttlH=0;
		let rtnH={'s':0,'l':0};
		let celBt=30;
		if(window.innerWidth<768){
			celBt=15;
		}
		popList.forEach((rv) =>{
			ttlH+=rv.getBoundingClientRect().height;
			ttlH+=2;
			if(cnt!=0){
				ttlH+=celBt;
			}
			cnt++;
			if(cnt==2){
				rtnH.s=ttlH;
			}
		});
		rtnH.l=ttlH;
		return rtnH;
	}
	
	
	const rvClose = () =>{
		setTimeout(() => {
			rvWrap.ariaHidden="true";
		}, "300");

		rvBt.ariaExpanded="false";
		rvWrap.style.height=ocH.s+"px";
	}
	const rvOpen = () =>{
		rvWrap.ariaHidden="false";
		rvBt.ariaExpanded="true";
		rvWrap.style.height=ocH.l+"px";
	}
	
	
	rvInit();
	rvClose();
	
	if(accFlg){
		rvBt.addEventListener("click",(e) =>{
			if(rvBt.ariaExpanded=="false"){
				rvOpen();
			}else{
				rvClose();
			}
		});
	}else{
		rvBt.remove();
	}
}

const lineupAcc = () =>{
	const linBt=document.querySelector(".opPrdBt");
	const linWrap=document.querySelector(".dtlLineup ul");
	const linList=linWrap.querySelectorAll("li");
	const lins=linList.length;
	let accFlg=true;
	let ocH;
	let clMgT=25;
	let clBet;
	
	
	const linInit = () =>{
		if(linList.length<=6){
			accFlg=false;
		}
		if(window.innerWidth<768){
			clBet=2;
		}else{
			clBet=6;
		}
		ocH=mathHeght();
		const term = 500;// タイマーの受取変数
		let timer = 0;
		let currentWidth = window.innerWidth;
		window.addEventListener('resize', ()=>{
			if (currentWidth == window.innerWidth) {
				// ウインドウ横幅が変わっていないため処理をキャンセル。
				return;
			}
			currentWidth = window.innerWidth;
			clearTimeout(timer);
			timer = setTimeout(function(){
				if(window.innerWidth<768){
					clBet=2;
				}else{
					clBet=6;
				}
				ocH=mathHeght();
				linClose();
			}, term);
			
		});
	}
	
	
	const mathHeght = () =>{
		linWrap.style.height="auto";
		const p=Math.ceil(lins/clBet);
		let ttlH=0;
		let rtnH={'s':0,'l':0};
		let minCnt=0;
		if(window.innerWidth<768){
			if(lins>=6){
				minCnt=2;
			}else{
				minCnt=Math.floor((lins-1)/2);
			}
		}else{
			minCnt=0;
		}
		for(let i=0;i<p;i++){
			ttlH+=linList[i*clBet].getBoundingClientRect().height;
			ttlH+=parseInt(window.getComputedStyle(linList[i*clBet]).marginTop);
			ttlH+=2;
			/*
			if(window.innerWidth<768){
				minCnt=2;
			}
			*/
			if(i==minCnt){
				rtnH.s=ttlH;
			}
		}
		rtnH.l=ttlH;
		return rtnH;
	}
	
	
	const linClose = () =>{
		setTimeout(() => {
			linWrap.ariaHidden="true";
		}, "300");

		linBt.ariaExpanded="false";
		linWrap.style.height=ocH.s+"px";
	}
	const linOpen = () =>{
		linWrap.ariaHidden="false";
		linBt.ariaExpanded="true";
		linWrap.style.height=ocH.l+"px";
	}
	
	linInit();
	linClose();
	
	if(accFlg){
		linBt.addEventListener("click",(e) =>{
			if(linBt.ariaExpanded=="false"){
				linOpen();
			}else{
				linClose();
			}
		});
	}else{
		linBt.remove();
	}
}
